import { Component } from '@angular/core';

@Component({
  selector: 'ws-site-services',
  templateUrl: './services.component.html'
})
export class SiteServicesComponent {}
